// tslint:disable:component-selector
import {
  Component,
  AfterViewChecked,
  OnInit,
  ElementRef,
  Renderer2,
  Input
} from '@angular/core';

@Component({
  selector: 'rti-carousel-item',
  templateUrl: './rti-carousel-item.html',
  styleUrls: ['./rti-carousel-item.scss']
})
export class RtiCarouselItem implements OnInit, AfterViewChecked {
  @Input() style: object;

  ngAfterViewChecked() {
  }

  ngOnInit() {
  }

  constructor(private el: ElementRef, private render: Renderer2) {
    this.style = {};
  }
}
